import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, resolveComponent as _resolveComponent, createBlock as _createBlock, createVNode as _createVNode, withCtx as _withCtx, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-50bec996"),n=n(),_popScopeId(),n)
const _hoisted_1 = { id: "user-corporate-page" }
const _hoisted_2 = {
  key: 0,
  class: "loading-wrapper"
}
const _hoisted_3 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  class: "loading",
  src: "/static/image/column3_bx_loader.gif"
}, null, -1))
const _hoisted_4 = [
  _hoisted_3
]
const _hoisted_5 = {
  key: 0,
  class: "mv content-section-sp-full"
}
const _hoisted_6 = ["src"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_user_new_articles = _resolveComponent("user-new-articles")!
  const _component_user_recruits = _resolveComponent("user-recruits")!
  const _component_user_columns = _resolveComponent("user-columns")!
  const _component_user_info = _resolveComponent("user-info")!
  const _component_user_image_gallery = _resolveComponent("user-image-gallery")!
  const _component_user_corporate_layout = _resolveComponent("user-corporate-layout")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    (_ctx.loading)
      ? (_openBlock(), _createElementBlock("div", _hoisted_2, _hoisted_4))
      : _createCommentVNode("", true),
    _createVNode(_component_user_corporate_layout, {
      "user-id": _ctx.userId,
      "medium-id": _ctx.mediumId,
      onFetchedUserAccount: _cache[0] || (_cache[0] = () => { _ctx.loading = false; })
    }, {
      default: _withCtx(({ userAccount }) => [
        (userAccount.eyecatchUrl)
          ? (_openBlock(), _createElementBlock("section", _hoisted_5, [
              _createElementVNode("img", {
                class: "mv-image",
                src: userAccount.eyecatchUrl,
                alt: ""
              }, null, 8, _hoisted_6)
            ]))
          : _createCommentVNode("", true),
        (userAccount.hasArticles)
          ? (_openBlock(), _createBlock(_component_user_new_articles, {
              key: 1,
              class: "content-section",
              "user-account-id": _ctx.userId,
              limit: 4,
              "enable-infinite-load": false,
              reader: _ctx.reader,
              "faved-article-ids": _ctx.favedArticleIds
            }, null, 8, ["user-account-id", "reader", "faved-article-ids"]))
          : _createCommentVNode("", true),
        _createVNode(_component_user_recruits, {
          class: "content-section",
          "user-account-id": _ctx.userId,
          "is-current-user-page": _ctx.isCurrentUserPage
        }, null, 8, ["user-account-id", "is-current-user-page"]),
        _createVNode(_component_user_columns, {
          class: "content-section",
          "user-account-id": _ctx.userId,
          "enable-infinite-load": false,
          "is-current-user-page": _ctx.isCurrentUserPage
        }, null, 8, ["user-account-id", "is-current-user-page"]),
        _createVNode(_component_user_info, {
          class: "content-section",
          "user-account": userAccount,
          "medium-id": _ctx.mediumId
        }, null, 8, ["user-account", "medium-id"]),
        (userAccount.hasGalleryImages)
          ? (_openBlock(), _createBlock(_component_user_image_gallery, {
              key: 2,
              class: "content-section",
              "user-id-hash": _ctx.userIdHash
            }, null, 8, ["user-id-hash"]))
          : _createCommentVNode("", true)
      ]),
      _: 1
    }, 8, ["user-id", "medium-id"])
  ]))
}